const SEARCH_STOP_WORDS = new Set([
  'a', 'an', 'and', 'at', 'by', 'for', 'from', 'in', 'of', 'on', 'the',
  'to', 'with', 'pty', 'ltd', 'limited', 'company', 'co',
]);

const STREET_ABBREVS = [
  [/\bav\b|\bave\b/g, 'avenue'],
  [/\bbvd\b|\bblvd\b/g, 'boulevard'],
  [/\bcct\b|\bcir\b/g, 'circuit'],
  [/\bcl\b/g, 'close'],
  [/\bct\b/g, 'court'],
  [/\bcr\b|\bcres\b/g, 'crescent'],
  [/\bdr\b/g, 'drive'],
  [/\besp\b/g, 'esplanade'],
  [/\bgr\b/g, 'grove'],
  [/\bhwy\b/g, 'highway'],
  [/\bln\b/g, 'lane'],
  [/\bpde\b/g, 'parade'],
  [/\bpl\b/g, 'place'],
  [/\brd\b/g, 'road'],
  [/\bst\b/g, 'street'],
  [/\btce\b/g, 'terrace'],
];

export function expandStreetTypeSearchTerms(value) {
  let out = String(value || '');
  for (const [pattern, replacement] of STREET_ABBREVS) out = out.replace(pattern, replacement);
  return out;
}

export const normaliseSearchText = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const normaliseSearchAddressText = (value) => expandStreetTypeSearchTerms(normaliseSearchText(value))
  .replace(/\s+/g, ' ')
  .trim();

function meaningfulSearchTermsFromNormalised(value) {
  return String(value || '')
    .split(' ')
    .filter(term => term.length >= 2 && !SEARCH_STOP_WORDS.has(term));
}

export function parseSearchIntent(value) {
  const raw = String(value || '');
  const quotedPhrases = [...raw.matchAll(/"([^"]+)"/g)]
    .map(match => normaliseSearchAddressText(match[1]))
    .filter(phrase => phrase.length >= 2);
  const unquoted = raw.replace(/"[^"]+"/g, ' ');

  return {
    phrases: quotedPhrases,
    terms: meaningfulSearchTermsFromNormalised(normaliseSearchAddressText(unquoted)),
  };
}

export function resultMatchesSearchIntent(da, searchText) {
  const intent = typeof searchText === 'string'
    ? parseSearchIntent(searchText)
    : searchText || { phrases: [], terms: [] };
  const haystack = normaliseSearchAddressText([
    da.da_number,
    da.council_application_number,
    da.planning_portal_app_number,
    da.address,
    da.description,
    da.applicant_name,
    da.applicant_company,
    da.builder_name,
    da.builder_company,
    da.architect_name,
    da.architect_company,
    da.planner_name,
    da.planner_company,
    da.certifier_name,
    da.certifier_company,
    da.engineer_name,
    da.engineer_company,
    da.surveyor_name,
    da.surveyor_company,
    da.owner_name,
  ].filter(Boolean).join(' '));

  return intent.phrases.every(phrase => haystack.includes(phrase))
    && intent.terms.every(term => haystack.includes(term));
}

export function filterSearchResultsForIntent(results, searchText) {
  const intent = parseSearchIntent(searchText);
  if (!intent.phrases.length && intent.terms.length <= 1) return results || [];
  return (results || []).filter(da => resultMatchesSearchIntent(da, intent));
}
